<template>
  <add-edit-dialog>
    <crm-panel :title="title">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          :disabled="isSubmitDisabled"
          @click="handleSave()"
        >
        </crm-button>
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleClose()">
        </crm-button>
      </div>
      <el-form
        label-position="right"
        label-width="150px"
        :rules="rules"
        ref="form"
        :model="form"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="项目名称：" prop="projectId">
              <el-select
                clearable
                filterable
                v-model="projectId"
                value-key="projectId"
                @change="handleChangeProject"
              >
                <el-option
                  v-for="item in projectListSelect"
                  :key="item.projectId"
                  :label="item.projectName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="!disableCustomer">
            <el-form-item label="客户名称：" prop="customerId">
              <el-select
                v-model="form.customerId"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请选择客户名称"
                :remote-method="handleQueryCustomer"
                :loading="customer.loading"
                @change="handleChangeCustomer"
              >
                <el-option
                  :key="`${item.name}_${item.uid}`"
                  v-for="item in projectCustomerSelect"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
                <el-option
                  v-if="projectCustomer.totalPages > customer.pageNumber"
                  label="点击加载更多"
                  value="点击加载更多"
                  :disabled="true"
                  style="cursor:pointer;"
                >
                  <span @click="handleMoreCustomList()">点击加载更多</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="10">
            <el-form-item label="关联合同：" prop="contractId">
              <el-select
                clearable
                v-model="form.contractId">
                <el-option
                  :key="item.contractNo"
                  v-for="item in projectContractSelect"
                  :label="item.contractNo"
                  :value="item.contractNo">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="业务员：" prop="salesmanCode">
              <el-select clearable v-model="form.salesmanCode">
                <el-option
                  :key="item.salesmanCode"
                  v-for="item in projectSalesmanSelect"
                  :label="item.salesmanName"
                  :value="item.salesmanCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import crmButton from '@/components/base/crmButton';
import crmPanel from '@/components/base/crmPanel';
import AddEditDialog from '@/components/base/addEditDialog';
import CusnameSelect from '@/components/business/custom/cusname-select';

export default {
  components: {
    crmButton,
    crmPanel,
    AddEditDialog,
    CusnameSelect,
  },
  props: {
    id: {
      type: String,
    },
    mode: {
      type: String,
    },
    detail: {
      type: Object,
      default: () => ({}),
    },
    customerId: {
      type: String,
    },
    customerName: {
      type: String,
    },
  },
  data() {
    return {
      title: '新增项目',
      projectId: '',
      customer: {
        name: '',
        loading: false,
        pageNumber: 1,
        pageSize: 20,
      },
      form: {
        projectId: null,
        salesmanCode: null,
        customerId: null,
      },
      rules: {
        projectId: [{ required: true, message: '请选择项目', trigger: 'blur' }],
        salesmanCode: [
          { required: true, message: '请选择业务员', trigger: 'blur' },
        ],
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'blur' },
        ],
        // contractId: [
        //   { required: true, message: '请选择合同编号', trigger: 'blur' },
        // ],
      },
      isSubmitDisabled: false,
      disableCustomer: false,
    };
  },
  computed: {
    ...mapGetters({
      projectListSelect: 'project/projectListSelect',
      projectCustomer: 'project/projectCustomer',
      projectCustomerSelect: 'project/projectCustomerSelect',
      projectContractSelect: 'project/projectContractSelect',
      projectSalesmanSelect: 'project/projectSalesmanSelect',
    }),
  },
  created() {
    if (this.id) {
      const val = this.detail;
      this.projectId = { projectId: val.projectId };
      this.form.projectId = val.projectId;
      this.form.projectName = val.projectName;
      this.form.projectSourceId = val.projectSourceId;
      this.form.customerId = val.customerId;
      this.form.salesmanCode = val.salesmanCode;
      this.form.id = val.id;
      this.$store.commit('project/GET_PROJECT_CUSTOMER_SELECT', [
        {
          uid: val.customerId,
          name: val.customerName,
        },
      ]);
      this.$store.commit('project/GET_PROJECT_SALESMAN_SELECT', [
        {
          salesmanCode: val.salesmanCode,
          salesmanName: val.salesmanName,
        },
      ]);
    } else if (this.customerId) {
      this.customer.name = this.customerName;
      this.getCustomerSelect(this.customer).then(() => {
        if (this.projectCustomerSelect.length === 1) {
          this.form.customerId = this.projectCustomerSelect[0].uid;
          this.handleQuerySalesman(this.projectCustomerSelect[0].uid);
        }
        // console.log(this.projectCustomer, this.customer);
      });
    } else {
      // 获取客户选择列表
      this.getCustomerSelect(this.customer).then(() => {
        // console.log(this.projectCustomer, this.customer);
      });
    }

    this.title = this.mode === 'update' ? '修改项目' : '新增项目';
    // 获取项目选择列表
    this.getProjectSelect();
  },
  methods: {
    ...mapActions({
      getProjectSelect: 'project/getProjectSelect',
      getCustomerSelect: 'project/getCustomerSelect',
      getContractSelect: 'project/getContractSelect',
      getSalesmanSelect: 'project/getSalesmanSelect',
      updateProject: 'project/updateProject',
      addProject: 'project/addProject',
      getProjectDetail: 'project/getProjectDetail',
    }),
    handleChangeProject(value) {
      this.form.projectId = value.projectId;
      this.form.projectName = value.projectName;
      this.form.projectSourceId = value.projectSourceId;
    },
    handleQueryCustomer(value) {
      this.customer.loading = true;
      this.customer.name = value;
      this.getCustomerSelect(this.customer).finally(() => {
        this.customer.loading = false;
      });
    },
    handleMoreCustomList() {
      this.customer.loading = true;
      this.customer.pageNumber += 1;
      this.getCustomerSelect(this.customer).finally(() => {
        this.customer.loading = false;
      });
    },
    handleChangeCustomer(value) {
      this.form.salesmanCode = undefined;

      this.customer.loading = true;
      this.customer.name = value;
      this.customer.pageNumber = 1;
      this.getCustomerSelect(this.customer).finally(() => {
        this.customer.loading = false;
      });

      if (value) {
        this.handleQuerySalesman(value);
      }
    },
    handleQueryContract(id) {
      this.getContractSelect({ customerId: id }).then(() => {
        if (this.projectContractSelect.length === 1) {
          this.form.contractId = this.projectContractSelect[0].id;
        }
      });
    },
    handleQuerySalesman(id) {
      this.getSalesmanSelect({ customerUid: id }).then(() => {
        if (this.projectSalesmanSelect.length === 1) {
          this.form.salesmanCode = this.projectSalesmanSelect[0].salesmanCode;
        }
      });
    },
    handleClose() {
      this.$emit('close');
    },
    // 新增|修改
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;

          const params = {};
          Object.keys(this.form).forEach((item) => {
            if (this.form[item]) {
              params[item] = this.form[item];
            }
          });
          this[`${this.mode}Project`]({
            ...params,
          })
            .then(() => {
              this.$message({
                type: 'success',
                message:
                  this.mode === 'update' ? '编辑项目成功' : '新增项目成功',
              });
              this.$emit('close');
              this.$emit('success');
            })
            .finally(() => {
              this.isSubmitDisabled = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less">
.addcompact-container {
  padding-right: 30px;
  .dialog-footer {
    text-align: right;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
